import DraftGameCard from '@gamiphy/loyalty-station-desktop/components/draftUser/components/DraftGameCard';
import SignIn from '@gamiphy/loyalty-station-desktop/components/draftUser/components/SignIn';
import { WelcomeGiftCard } from '@gamiphy/loyalty-station-desktop/components/welcomeGift/card';
import { SurveyCard } from '@gamiphy/loyalty-station-desktop/components/welcomeGift/tab/cards';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { GameStore } from '@gamiphy/loyalty-station-desktop/store/game';
import { SurveyStore } from '@gamiphy/loyalty-station-desktop/store/survey';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { Trans } from '@gamiphy/react-i18n';
import {
  Box, Card, CardContent, Grid, Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

type Props = {
  setCheckLater: (arg: boolean) => void,
}

const DraftUserPage: React.FC<Props> = observer(({ setCheckLater }) => {
  const showSurvey = React.useMemo(
    () => SurveyStore.isAvailable &&
      SurveyStore.appSurvey &&
      AppStore.app.featureFlags.legacyWelcomeGift,
    [
      SurveyStore.isAvailable,
      SurveyStore.appSurvey,
      AppStore.app],
  );

  const showGame = React.useMemo(
    () => GameStore.hasGames &&
      AppStore.app.featureFlags.legacyWelcomeGift,
    [
      GameStore.hasGames,
      GameStore.appGame,
      AppStore.app],
  );

  const description = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        return (
          <Trans
            i18nKey="draft.user.coupon.finishActions"
            defaults="Complete one of these actions to get your coupon"
          />
        );
      case WelcomeGiftTypes.points:
        return (
          <Trans
            i18nKey="draft.user.points.finishActions"
            defaults="Complete these actions to get your {{, gems}}"
            values={{}}
          />
        );
      default:
        return null;
    }
  }, [WelcomeGiftStore.type]);

  return (
    <Box sx={{
      position: 'relative',
      height: '100%',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: 0,
      '&::-webkit-scrollbar': {
        display: 'none',
        msOverflowStyle: 'none',
      },
      scrollbarWidth: 'none',
    }}
    >
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        sx={{
          flex: '1 1 auto',
          height: '100%',
          overflowY: 'scroll',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '0px',
            background: 'transparent',
          },
        }}
        wrap="nowrap"
      >
        <Grid>
          <Box sx={{
            display: 'grid',
            gap: 1,
            p: 2,
            pb: 1,
          }}
          >
            {AppStore.app.featureFlags.legacyWelcomeGift && (
              <WelcomeGiftCard />
            )}
            {!WelcomeGiftStore.unlocked && (showSurvey || showGame) && (
              <>
                <Typography sx={{ fontSize: '12px', fontWeight: 700 }}>
                  {description}
                </Typography>
                {showSurvey && (
                  <Card>
                    <CardContent>
                      <SurveyCard />
                    </CardContent>
                  </Card>
                )}
                {showGame && GameStore.appGame && <DraftGameCard appGame={GameStore.appGame} />}
              </>
            )}
            <SignIn setCheckLater={setCheckLater} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
});

export default DraftUserPage;
